import React from 'react';

/*
  Rabbit Box Ads official brand logos (from brand book).
  Variants:
    - 'mark'         : icon only (gold, transparent bg) — for compact spots
    - 'wordmark-dark': gold mark + black wordmark — for cream/light bgs
    - 'wordmark-light': all white version — for dark bgs
    - 'mark-only-gold': solo gold mark on transparent
*/

const LOGO_ASSETS = {
  markGold: 'https://customer-assets-cm19k8pv.emergentagent.net/job_rabbit-web-craft/artifacts/dfvqmxu6_Logo-01.webp',
  wordmarkGoldBlack: 'https://customer-assets-cm19k8pv.emergentagent.net/job_rabbit-web-craft/artifacts/l5xhh4r9_Logo-06.webp',
  wordmarkWhite: 'https://customer-assets-cm19k8pv.emergentagent.net/job_rabbit-web-craft/artifacts/zt16culh_Logo-05.webp',
  wordmarkBlack: 'https://customer-assets-cm19k8pv.emergentagent.net/job_rabbit-web-craft/artifacts/8izujq2x_Logo-04.webp',
  markGoldSmall: 'https://customer-assets-cm19k8pv.emergentagent.net/job_rabbit-web-craft/artifacts/xy4r02gn_Logo-03.webp',
};

export { LOGO_ASSETS };

export default function Logo({ variant = 'mark', className = 'h-8 w-8' }) {
  let src = LOGO_ASSETS.markGold;
  let alt = 'Rabbit Box Ads';
  if (variant === 'wordmark-dark') src = LOGO_ASSETS.wordmarkGoldBlack;
  else if (variant === 'wordmark-light') src = LOGO_ASSETS.wordmarkWhite;
  else if (variant === 'wordmark-black') src = LOGO_ASSETS.wordmarkBlack;
  else if (variant === 'mark-small') src = LOGO_ASSETS.markGoldSmall;

  return <img src={src} alt={alt} className={className} draggable="false" />;
}
